import { getData } from "actions";
import { Breadcrumb, CardContainer, Container, SmallCard } from "components";
import { API_URL_agent } from "constants/api";
import { AuthContext } from "context/AuthContext";
import React, { useCallback, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { agentReducers } from "redux/agentSlice";

const Profile = () => {
  const dispatch = useDispatch();
  const { datauser } = useContext(AuthContext);
  const { getAgentResult } = useSelector((state) => state.agent);

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_agent,
        params,
        { dispatch, redux: agentReducers },
        "GET_AGENT"
      );
    },
    [dispatch]
  );

  const fetchData = useCallback(() => {
    //get id 1 for setting
    const params = `${datauser.id}/`;
    get(params);
  }, [get, datauser]);

  useEffect(() => {
    if (datauser !== "") fetchData();
  }, [datauser]);

  return (
    <Container>
      <Breadcrumb
        title={"Infomation Profile"}
        excludedPaths={["profile", "dashboard"]}
      />
      <CardContainer title={"Profile"}>
        <div className="grid grid-cols-1 md:grid-cols-12 justify-between">
          <SmallCard title={"User information"} className="col-span-6">
            {getAgentResult.id && (
              <div className="m-4">
                <div className="grid grid-cols-1 lg:grid-cols-12 mb-2">
                  <label className="font-bold col-span-4">Gender:</label>
                  <p className="col-span-8">
                    {getAgentResult.gender === 1 ? "Male" : "Female"}
                  </p>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-12 mb-2">
                  <label className="font-bold col-span-4">Departement:</label>
                  <p className="col-span-8">
                    {getAgentResult.primary_dpt_name}
                  </p>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-12 mb-2">
                  <label className="font-bold col-span-4">Group:</label>
                  <p className="col-span-8">{getAgentResult.groups_name[0]}</p>
                </div>
              </div>
            )}
          </SmallCard>
          <SmallCard title={"Contact information"} className=" col-span-6">
            {getAgentResult.id && (
              <div className="m-4">
                <div className="grid grid-cols-1 lg:grid-cols-12 mb-2">
                  <label className="font-bold col-span-4">Email:</label>
                  <p className="col-span-8">{getAgentResult?.email}</p>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-12 mb-2">
                  <label className="font-bold col-span-4">Phone Number:</label>
                  <p className="col-span-8">
                    {getAgentResult?.phone_number === null
                      ? ""
                      : getAgentResult.phone_number}
                  </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 mt-4 gap-4">
                  <Link
                    className="col-span-6 text-white rounded py-2 bg-primary-500 hover:bg-primary-700 text-center"
                    to={"/dashboard/profile/informationprofile/formprofile"}
                    state={getAgentResult}
                  >
                    Edit Profile
                  </Link>
                  <Link
                    className="col-span-6 text-white rounded py-2 bg-red-500 hover:bg-red-700 text-center"
                    to={"/dashboard/profile/informationprofile/changepassword"}
                    state={getAgentResult}
                  >
                    Change Password
                  </Link>
                </div>
              </div>
            )}
          </SmallCard>
        </div>
      </CardContainer>
    </Container>
  );
};

export default Profile;
